import User from './User'
import Notification from './Notification'
export default class Link {
  constructor(objIn = {}) {
    const defaults = {
      //ID is required
      ID: 0,
      //TrackedBillID is required
      TrackedBillID: 0,
      Description: null,
      URL: null,
      //CreatedByID is required
      CreatedByID: 0,
      CreatedDate: null,
      //IsDeleted is required
      IsDeleted: false,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.ID = obj.ID
    this.TrackedBillID = obj.TrackedBillID
    this.Description = obj.Description
    this.URL = obj.URL
    this.CreatedByID = obj.CreatedByID
    this.CreatedDate = obj.CreatedDate
    this.IsDeleted = obj.IsDeleted
    this.CreatedBy = new User(obj.CreatedBy || {})
    this.Notifications = []
    if (obj.Notifications) {
      obj.Notifications.forEach((item) => {
        this.Notifications.push(new Notification(item))
      })
    }
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.CreatedBy = null
    obj.Notifications = []
    if (this.Notifications) {
      this.Notifications.forEach((item) => {
        obj.Notifications.push(item.removeRelated())
      })
    }
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.CreatedBy = null
    obj.Notifications = null
    return obj
  }
}
